var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 14 18",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.5 3.75h3c.82875 0 1.5.67125 1.5 1.5v9.75c0 .82875-.67125 1.5-1.5 1.5h-9c-.82875 0-1.5-.67125-1.5-1.5v-9.75c0-.82875.67125-1.5 1.5-1.5h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.19325 7.99425c.65901.65901.65901 1.727475 0 2.386485s-1.727475.65901-2.386485 0-.65901-1.727475 0-2.386485 1.727475-.65901 2.386485 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.69625 14.25c-.13125-.32925-.33375-.62475-.594-.8655-.44025-.408-1.01775-.6345-1.61775-.6345h-.969c-.6 0-1.1775.2265-1.61775.6345-.26025.24075-.46275.53625-.594.8655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.75 5.25h-1.5c-.414 0-.75-.336-.75-.75v-2.25c0-.414.336-.75.75-.75h1.5c.414 0 .75.336.75.75v2.25c0 .414-.336.75-.75.75z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.285434b10f50d9cbde7bc6f87d95cc43.svg";
export { ForwardRef as ReactComponent };